export const WAVE_GRAPHQL = {
    listOceanSpaces: `query{listOceanSpaces{spaceId title icon color visibility shareable reserved memberCount myRole listSource createdAt updatedAt}}`,
    getOceanSpace: `query($id:ID!){getOceanSpace(spaceId:$id){spaceId title icon color visibility shareable reserved memberCount myRole listSource createdAt updatedAt}}`,
    createOceanSpace: `mutation($i:CreateOceanSpaceInput!){createOceanSpace(input:$i){spaceId title icon color visibility shareable reserved memberCount myRole listSource createdAt updatedAt}}`,
    updateOceanSpace: `mutation($i:UpdateOceanSpaceInput!){updateOceanSpace(input:$i){spaceId title icon color visibility shareable reserved memberCount myRole listSource createdAt updatedAt}}`,
    deleteOceanSpace: `mutation($id:ID!){deleteOceanSpace(spaceId:$id)}`,
    listOceanSpaceMembers: `query($id:ID!){listOceanSpaceMembers(spaceId:$id){spaceId sub email role addedAt}}`,
    addSpaceMember: `mutation($id:ID!,$email:String!,$role:OceanSpaceRole!){addSpaceMember(spaceId:$id,email:$email,role:$role){spaceId sub email role addedAt}}`,
    updateSpaceMemberRole: `mutation($id:ID!,$sub:ID!,$role:OceanSpaceRole!){updateSpaceMemberRole(spaceId:$id,sub:$sub,role:$role){spaceId sub email role addedAt}}`,
    removeSpaceMember: `mutation($id:ID!,$sub:ID!){removeSpaceMember(spaceId:$id,sub:$sub)}`,
    listWaves: `query($s:ID!){listWaves(spaceId:$s){items{waveId spaceId title status templateId formatVersion ownerSub latestSnapshotSeq latestSnapshotB64 nextOpSeq coverImageS3Key createdAt updatedAt} nextToken}}`,
    listParticipatingWaves: `query($l:Int){listParticipatingWaves(limit:$l){items{waveId role joinedAt} nextToken}}`,
    getWave: `query($id:ID!){getWave(waveId:$id){waveId spaceId title status templateId formatVersion ownerSub participants{sub email displayName role joinedAt} latestSnapshotSeq latestSnapshotB64 nextOpSeq coverImageS3Key coverImageHeaderS3Key createdAt updatedAt}}`,
    createWave: `mutation($i:CreateWaveInput!){createWave(input:$i){waveId spaceId title status templateId formatVersion ownerSub participants{sub email displayName role joinedAt} latestSnapshotSeq latestSnapshotB64 nextOpSeq coverImageS3Key coverImageHeaderS3Key createdAt updatedAt}}`,
    requestWaveCoverImage: `mutation($id:ID!,$force:Boolean){requestWaveCoverImage(waveId:$id,force:$force){ok cached skipped jobId coverImageS3Key coverImageHeaderS3Key reason}}`,
    appendOps: `mutation($w:ID!,$o:[String!]!){appendWaveOps(waveId:$w,opsB64:$o){waveId nextOpSeq authorSub ops{opId waveId authorSub dataB64 seq createdAt}}}`,
    listOpsSince: `query($w:ID!,$a:Int,$t:String){listWaveOpsSince(waveId:$w,afterSeq:$a,nextToken:$t){items{opId waveId authorSub dataB64 seq createdAt} nextToken}}`,
    getWaveYjsSync: `query($w:ID!,$sv:String){getWaveYjsSync(waveId:$w,stateVectorB64:$sv){waveId updateB64 serverStateVectorB64 snapshotSeq nextOpSeq formatVersion}}`,
    publishSnapshot: `mutation($w:ID!,$s:String!,$n:Int,$fv:String){publishWaveSnapshot(waveId:$w,snapshotB64:$s,snapshotSeq:$n,formatVersion:$fv){waveId formatVersion}}`,
    updateStatus: `mutation($w:ID!,$s:WaveStatus!){updateWaveStatus(waveId:$w,status:$s){waveId spaceId title status templateId formatVersion ownerSub latestSnapshotSeq latestSnapshotB64 nextOpSeq createdAt updatedAt}}`,
    updateWave: `mutation($w:ID!,$i:UpdateWaveInput!){updateWave(waveId:$w,input:$i){waveId spaceId title status templateId formatVersion ownerSub latestSnapshotSeq latestSnapshotB64 nextOpSeq createdAt updatedAt}}`,
    postBlip: `mutation($i:PostWaveBlipInput!){postWaveBlip(input:$i){blipId waveId blockAnchorId authorSub body createdAt updatedAt}}`,
    listBlips: `query($w:ID!){listWaveBlips(waveId:$w){blipId waveId blockAnchorId authorSub body createdAt updatedAt}}`,
    listPresences: `query($w:ID!){listWavePresences(waveId:$w){waveId sub clientId displayName blockAnchorId cursorOffset cursorEndOffset updatedAt}}`,
    listLastSeen: `query($w:ID!){listWaveLastSeen(waveId:$w){sub lastSeenAt displayName}}`,
    inviteParticipant: `mutation($i:InviteWaveParticipantInput!){inviteWaveParticipant(input:$i){sub email role joinedAt}}`,
    joinWaveViaLink: `mutation($w:ID!){joinWaveViaLink(waveId:$w){sub email displayName role joinedAt}}`,
    getAIJob: `query($id:ID!){getAIJob(jobId:$id){jobId status feature providerUsageJson outputAssetKey outputAssetMime errorMessage costCents}}`,
    listOceanMissionSteps: `query ListOceanMissionSteps($jobId: ID!, $limit: Int) {
    listOceanMissionSteps(jobId: $jobId, limit: $limit) {
      items { seq kind summary detailJson parentSeq createdAt }
    }
  }`,
    listOceanAgents: `query ListOceanAgents($orgId: ID, $limit: Int, $nextToken: String) {
    listOceanAgents(orgId: $orgId, limit: $limit, nextToken: $nextToken) {
      items { id name role icon iconS3Key enabled appIds }
      nextToken
    }
  }`,
    onAIJobChanged: `subscription OnAIJobChanged($jobId: ID) {
    onAIJobChanged(jobId: $jobId) {
      jobId status feature providerUsageJson outputAssetKey errorMessage costCents
    }
  }`,
    upsertProfile: `mutation{upsertProfile{userId email displayName}}`,
    publishPresence: `mutation($i:PublishWavePresenceInput!){publishWavePresence(input:$i){sub clientId displayName blockAnchorId cursorOffset cursorEndOffset updatedAt}}`,
    submitAIJob: `mutation($input:SubmitAIJobInput!){submitAIJob(input:$input){jobId kind status feature createdAt}}`,
    onWaveOps: `subscription OnWaveOps($waveId: ID!) {
    onWaveOps(waveId: $waveId) {
      waveId
      nextOpSeq
      authorSub
      ops { opId waveId authorSub dataB64 seq createdAt }
    }
  }`,
    onWaveStatusChanged: `subscription OnWaveStatusChanged($waveId: ID!) {
    onWaveStatusChanged(waveId: $waveId) {
      waveId spaceId title status templateId formatVersion ownerSub latestSnapshotSeq latestSnapshotB64 nextOpSeq createdAt updatedAt
    }
  }`,
    onWaveBlip: `subscription OnWaveBlip($waveId: ID!) {
    onWaveBlip(waveId: $waveId) {
      blipId waveId blockAnchorId authorSub body createdAt updatedAt
    }
  }`,
    onWavePresence: `subscription OnWavePresence($waveId: ID!) {
    onWavePresence(waveId: $waveId) {
      waveId sub clientId displayName blockAnchorId cursorOffset cursorEndOffset updatedAt
    }
  }`,
    listChatMessages: `query ListWaveChatMessages($waveId: ID!, $limit: Int, $nextToken: String) {
    listWaveChatMessages(waveId: $waveId, limit: $limit, nextToken: $nextToken) {
      items {
        messageId waveId authorSub authorKind authorName body parentId mentions status
        createdAt replyCount lastReplyAt reactionCounts { emoji count } viewerReactions
      }
      nextToken
    }
  }`,
    listChatReplies: `query ListWaveChatReplies($waveId: ID!, $parentId: ID!, $limit: Int, $nextToken: String) {
    listWaveChatReplies(waveId: $waveId, parentId: $parentId, limit: $limit, nextToken: $nextToken) {
      items {
        messageId waveId authorSub authorKind authorName body parentId mentions status
        createdAt replyCount lastReplyAt reactionCounts { emoji count } viewerReactions
      }
      nextToken
    }
  }`,
    getChatReadState: `query GetWaveChatReadState($waveId: ID!) {
    getWaveChatReadState(waveId: $waveId) {
      waveId sub lastReadMessageId lastReadAt updatedAt
    }
  }`,
    postChatMessage: `mutation PostWaveChatMessage($input: PostWaveChatMessageInput!) {
    postWaveChatMessage(input: $input) {
      messageId waveId authorSub authorKind authorName body parentId mentions status
      createdAt replyCount lastReplyAt reactionCounts { emoji count } viewerReactions
    }
  }`,
    toggleChatReaction: `mutation ToggleWaveChatReaction($input: ToggleWaveChatReactionInput!) {
    toggleWaveChatReaction(input: $input) {
      messageId waveId authorSub authorKind authorName body parentId mentions status
      createdAt replyCount lastReplyAt reactionCounts { emoji count } viewerReactions
    }
  }`,
    markChatRead: `mutation MarkWaveChatRead($input: MarkWaveChatReadInput!) {
    markWaveChatRead(input: $input) {
      waveId sub lastReadMessageId lastReadAt updatedAt
    }
  }`,
    onWaveChatMessage: `subscription OnWaveChatMessage($waveId: ID!) {
    onWaveChatMessage(waveId: $waveId) {
      messageId waveId authorSub authorKind authorName body parentId mentions status
      createdAt replyCount lastReplyAt reactionCounts { emoji count } viewerReactions
    }
  }`,
    onWaveChatReaction: `subscription OnWaveChatReaction($waveId: ID!) {
    onWaveChatReaction(waveId: $waveId) {
      messageId waveId authorSub authorKind authorName body parentId mentions status
      createdAt replyCount lastReplyAt reactionCounts { emoji count } viewerReactions
    }
  }`,
    createTodo: `mutation($input:CreateTodoInput!){createTodo(input:$input){todoId text completed categories projectId priority dueDate updatedAt}}`,
    updateTodo: `mutation($id:ID!,$input:UpdateTodoInput!){updateTodo(todoId:$id,input:$input){todoId text completed categories projectId priority dueDate updatedAt}}`,
    registerPushDevice: `mutation RegisterPushDevice($input: RegisterPushDeviceInput!) {
    registerPushDevice(input: $input) { appId deviceId platform registeredAt }
  }`,
    unregisterPushDevice: `mutation UnregisterPushDevice($input: UnregisterPushDeviceInput!) {
    unregisterPushDevice(input: $input)
  }`,
    enqueueWaveNotification: `mutation EnqueueWaveNotification($input: EnqueueWaveNotificationInput!) {
    enqueueWaveNotification(input: $input) { ok sentCount skippedCount prunedTokenCount }
  }`,
};
export const WAVE_APP_ID = "wave";
